import apiClient from "../apiClient";

export const DepartmentsAPI = {
  getAll: () => apiClient.get("/api/v1/departments"),
  getAllPaginated: (params) => {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== "") {
        searchParams.append(key, String(value));
      }
    });
    return apiClient.get(`/api/v1/departments/list?${searchParams.toString()}`);
  },
  getById: (id) => apiClient.get(`/api/v1/departments/list/${id}`),
  create: (payload) => apiClient.post(`/api/v1/departments`, payload),
  update: ({ id, payload }) =>
    apiClient.put(`/api/v1/departments/${id}`, payload),
  delete: (id) => apiClient.delete(`/api/v1/departments/${id}`),
};
